import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Permissions } from '../interfaces/security-configuration.interface';

const permissions1: Permissions = {
  sections: [
    { name: 'dashboard', hasPermission: true },
    { name: 'chat', hasPermission: true }
  ],
  actions: [
    { name: 'action1', hasPermission: true },
    { name: 'action2', hasPermission: true }
  ]
};

const permissions2: Permissions = {
  sections: [
    { name: 'dashboard', hasPermission: true },
    { name: 'chat', hasPermission: false }
  ],
  actions: [
    { name: 'action1', hasPermission: false },
    { name: 'action2', hasPermission: true }
  ]
};

@Injectable({
  providedIn: 'root'
})
export class SecurityPermissionsService {

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE', // OPTIONS
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
    })
  };

  constructor(private http: HttpClient) { }

  getPermission(url: string): Observable<Permissions> {
    return this.http.get<Permissions>(url, this.httpOptions);
  }

  getMockPermissions(user: string) {
    if (user === 'user1') {
      return permissions1;
    }
    if (user === 'user2') {
      return permissions2;
    }
  }

  hasAccess(keyName: string, sections: any) {
    let permission = false;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].Name === keyName) {
        permission = sections[i].HasPermission;
      }
    }
    return permission;
  }

  hasPermission(keyName: string, actions: any) {
    let permission = false;
    for (let i = 0; i < actions.length; i++) {
      if (actions[i].Name === keyName) {
        permission = actions[i].HasPermission;
      }
    }
    return permission;
  }
}
